module.exports = __webpack_public_path__ + "img/遥感商城logo.42fa5987.png";